<template>
  <section class="form-section mb-4">
    <div class="d-flex align-center justify-space-between mb-3">
      <div class="d-flex align-center">
        <v-icon v-if="icon" class="mr-2" color="primary" size="20">
          {{ icon }}
        </v-icon>
        <h4 class="text-subtitle-1 font-weight-medium">{{ title }}</h4>
      </div>
      <slot name="actions" />
    </div>
    <slot />
  </section>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    default: "",
  },
});
</script>

<style scoped>
.form-section {
  padding: 16px;
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  border-radius: 10px;
}
</style>
